import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { useSelector } from "react-redux";
import Loader from "../Loader/Loader";

const IPWhitelistingModal = ({ show, handleClose }) => {
  const [formData, setFormData] = useState(["", "", ""]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const customerSummary = useSelector((state) => state.balance.customerSummary);
  const loggedInUserName = sessionStorage.getItem("username");

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9.]*$/.test(value)) {
      const updatedIPs = [...formData];
      updatedIPs[index] = value;
      setFormData(updatedIPs);
    }
  };

  const validate = () => {
    const newErrors = {};
    const ipRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;

    const hasAtLeastOneIP = formData.some((ip) => ip.trim() !== "");

    if (!hasAtLeastOneIP) {
      newErrors.general = "At least one IP address is required";
    }

    formData.forEach((ip, index) => {
      if (ip.trim() && !ipRegex.test(ip.trim())) {
        newErrors[index] = "Please enter a valid IP address";
      }
    });

    return newErrors;
  };

  const handleFetchIpWhitelistList = async () => {
    try {
      const payload = {
        username: loggedInUserName,
        companyCode: customerSummary[0]?.customerCode || "",
      };
      setLoading(true);
      const response = await axiosPostApi(
        apiList.FETCH_IP_WHITE_LISTING,
        payload
      );

      if (response?.data?.status && response?.data?.respCode === "00") {
        const ipArray = response.data.data.map((item) => item.ip);
        setFormData(
          ipArray.length >= 3 ? ipArray : [...ipArray, "", "", ""].slice(0, 3)
        );
      } else {
        CustomAlert({
          title: "Failed",
          text: response.data.message || "Failed to submit data",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while submitting. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      handleFetchIpWhitelistList();
    }
  }, [show]);

  const handleIpWhitelist = async (ipArray) => {
    try {
      const payload = {
        username: loggedInUserName,
        companyCode: customerSummary[0]?.customerCode || "",
        companyName: customerSummary[0]?.name || "",
        ipList: ipArray,
      };
      const response = await axiosPostApi(
        apiList.IP_WHITE_LISTING_CREATE,
        payload
      );

      if (response?.data?.status && response?.data?.respCode === "00") {
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "Ok",
        });
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text: response.data.message || "Failed to submit data",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while submitting. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const filteredIPs = formData.filter((ip) => ip.trim() !== "");
      handleIpWhitelist(filteredIPs);
    }
  };

  const handleCancel = () => {
    setFormData(["", "", ""]);
    setErrors({});
    handleClose();
  };

  return (
    <>
      {loading && <Loader />}
      <div
        className={`modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div
          className="modal-dialog"
          role="document"
          style={{ maxWidth: "480px", margin: "1.75rem auto" }}
        >
          <div className="modal-content" style={{ margin: 0, padding: 0 }}>
            <div className="modal-header">
              <h5 className="modal-title main-title">Add IP Whitelisting</h5>
            </div>
            <div className="modal-body" style={{ padding: "2rem 1rem 1rem 1rem" }}>
              {formData.map((ip, index) => (
                <div
                  className="row mb-3"
                  key={index}
                  style={{ marginRight: 0, marginLeft: 0, justifyContent: "space-between" }}
                >
                  <label
                    className="col-md-3 col-form-label"
                    style={{ paddingRight: "5px", paddingLeft: "5px" }}
                  >
                    IP Address
                  </label>
                  <div
                    className="col-md-8"
                    style={{ paddingRight: "5px", paddingLeft: "5px" }}
                  >
                    <input
                      type="text"
                      className="form-control text-center"
                      value={ip}
                      onChange={(e) => handleInputChange(e, index)}
                      placeholder="Enter IP Address"
                      style={{ width: "90%", boxSizing: "border-box" }}
                    />
                    {errors[index] && (
                      <span className="error">{errors[index]}</span>
                    )}
                  </div>
                </div>
              ))}
              {errors.general && (
                <div className="row mb-3" style={{ marginRight: 0, marginLeft: 0 }}>
                  <div
                    className="col-md-8 offset-md-3"
                    style={{ paddingRight: "5px", paddingLeft: "5px" }}
                  >
                    <span className="error">{errors.general}</span>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-back"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-submit"
                onClick={handleSubmit}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default IPWhitelistingModal;